<template>
  <div class="animated fadeIn list-of-coa">
    <b-card>
      <div slot="header">Chart of Cash Flow Account
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="refresh()"><i class="fa fa-refresh"></i> Refresh</button>
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="print">Print</b-button>
          <b-button variant="btn btn-primary mr-1" @click="exportXls">Export</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="3">
          <b-form-group label-cols=3 label="Account Code">
            <b-form-input v-model="tblData.kodecash"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="4">
          <b-form-group label-cols=3 label="Account Name">
            <b-form-input v-model="tblData.namacash"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table" 
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblData.fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
      >
        <template v-slot:cell(kodecash)="data">
          <span v-if="(data.item.judul=='Y')" style="font-weight:bold;">{{data.item.kodecash}}</span>
          <span v-else>{{data.item.kodecash}}</span>
        </template>
        <template v-slot:cell(accname)="data">
          <span v-if="(data.item.judul=='Y')" v-html="data.item.accname" style="font-weight:bold;"></span>
          <span v-else v-html="data.item.accname"></span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <b-modal v-model="showForm" header-bg-variant="primary"  :title="formTitle" :centered="true" @ok="handleOk">
      <b-form @submit.stop.prevent="save">
          <b-form-group label-cols=3 label="Account Code" >
            <b-form-input v-model="model.kodecash" id="inputKodeacc" aria-describedby="inputKodeaccFeedback" :state="$v.model.kodecash.required"></b-form-input>
            <b-form-invalid-feedback id="inputKodeaccFeedback">
              Field is required 
            </b-form-invalid-feedback>            
          </b-form-group>
          
          <b-form-group label-cols=3 label="Account Name">
            <b-form-input v-model="model.namacash" id="inputNamaacc" aria-describedby="inputNamaaccFeedback" :state="$v.model.namacash.required"></b-form-input>
            <b-form-invalid-feedback id="inputNamaaccFeedback">
              Field is required 
            </b-form-invalid-feedback>            
          </b-form-group>
          <b-form-group label-cols=3 label="Account Type">
             <b-form-select v-model="model.jenis" :plain="true" :options="accountType" :state="$v.model.jenis.required"></b-form-select>
          </b-form-group>
      </b-form>
    </b-modal>

    </b-card>
    <b-modal v-model="showReport" size="xl" scrollable title="Print Cash Flow Account">
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">
.list-of-coa {
iframe {
  border: 1px solid #ccc;
  width: 100%;
  height: 11in;
}

}
</style>


<script>
import toastr from "mini-toastr";
import coa from "../../apis/cashflowacc";
import { validationMixin } from "vuelidate";
import { required, maxLength,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      kodecash: {
        required,
         maxLength: maxLength(50)
      },
      namacash: {
        required,
         maxLength: maxLength(100)
      },
      jenis: { required },
    }
  },  
  data() {
    return {
      accountType : [{ value: 'IN', text: 'Cash Inflow' },
                { value: 'OUT', text: 'Cash Outflow' },
            ],
      formTitle: 'Add - Cash Flow Account',
      showForm:false,
      showReport:false,
      showDelConfirm: false,
      horizontal: true,
      model:{},
      tblData: {
        items: [],
        fields: [
          {
            key: "kodecash",
            label: "Account Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "accname",
            label: "Account Name",
          },
          {
            key: "typeacc",
            thStyle: "width:100px",
            label: "Type"
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:100px",
            thClass: "text-center",
          },

        ],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        kodecash: "",
        namacash: "",
      },
      reportUrl: null
    };
  },
  computed: {
    filterKode() {
      return this.tblData.kodecash;
    },
    filterNama() {
      return this.tblData.namacash;
    },
    isValid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
  },
  watch: {
    filterKode: function(kodecash) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (kodecash == tblData.kodecash) refresh();
      }, 500);
    },
    filterNama: function(namacash) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (namacash == tblData.namacash) refresh();
      }, 500);
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await coa.list(this.tblData);      
      return list;
    },
    add: function() {
      this.model = { kodecash: '', namacash:'' };
      this.formTitle='Add - Cash Flow Account';
      this.showForm = true;
    },
    edit: function(data) {
      const item={};
      for (var key in data) {
          if (data[key])
          item[key] = data[key];
      }      
      this.model = item;
      this.model.kodelama=item.kodecash;
      this.formTitle='Edit - Cash Flow Account';
      this.showForm = true;
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    handleOk: function(evt) {
      const { model, isValid } = this;
        // console.log('isValid : ', isValid)
      evt.preventDefault()
      if (!isValid) {
        alert('Please fill the form correctly.')
      } else {
        this.save()
      }
    },
    save: async function() {
      const { model, isValid } = this;
      if (isValid==true) {
        try {
          if (this.formTitle == "Add - Cash Flow Account") {
            await coa.insert(model);
          } else {
            await coa.update(model);
          }
          this.showForm = false;
          this.refresh();
        } catch (error) {
            // console.log('save : ', error)
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");
        }
      }
    },
    deleteData: async function() {
      await coa.remove(this.model);
      this.refresh();
    },
    print: async function() {
          try {
                this.showReport=true;
                const obj = { kodecash: this.tblData.kodecash ||'', namacash: this.tblData.namacash ||'' };
              this.reportUrl= await coa.print(obj);
              this.isprintjv=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }

    },
    exportXls: function() {
      coa.exportXls(this.tblData);
    },
    refresh() {
      this.$refs.table.refresh();
    }
  }
};
</script>
